import styled from 'styled-components';

export const VerticalNavigationMenu = styled.ul`
  flex: 0 0 80px;
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  background: white;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  overflow-y: auto;
`;

export const Img = styled.img`
  width: 55px;
  height: 55px;
`;

export const Button = styled.button`
  background-color: transparent !important;
  border-radius: 0;
  line-height: 20px;
  padding: 10px;
  margin: 0;
  overflow: visible;
`;

export const FlagButton = styled.button`
  line-height: 55px;
  height: 55px;
  background-color: transparent !important;
  border-radius: 0;
  padding: 0;
  margin: 0;
`;

export const Icon = styled.i`
  margin: 0;
  text-shadow: none;
  line-height: 20px;
  font-size: 20px;
  height: 20px;
  width: 20px;
  padding: 0;
`;

export const NavigationIcon = styled.li`
  margin-bottom: 16px;

  i {
    transition: color 0.12s ease-in-out;
    color: #8f959f;
  }

  path {
    transition: fill 0.12s ease-in-out;
  }

  path:not(.icon_svg__doNotFill) {
    fill: #8f959f;
  }

  &:hover {
    i {
      color: #383c42;
    }

    path:not(.icon_svg__doNotFill) {
      fill: #383c42;
    }
  }

  ${({ isSelected }) =>
    isSelected
      ? `
      position: relative;
      i {
        color: #383C42;
      }
      path:not(.icon_svg__doNotFill) {
        fill: #383C42;
      }
      &:after {
        content: ' ';
        position: absolute;
        width: 6px;
        height: 6px;
        box-sizing: border-box;
        border: none;
        border-radius: 50%;
        background-color: #7ed321;
        display: block;
        left: 50%;
        transform: translateX(-50%);
        bottom: -6px;
      }`
      : ''}
  &:first-of-type {
    margin-top: 16px;
  }
`;

export const FlagNavigationIcon = styled(NavigationIcon)`
  opacity: 1;
  &:hover {
    opacity: 1;
  }
`;

export const IconBadgeWrapper = styled.div`
  position: relative;
`;
